import './Accordion.scss';
import { FaChevronCircleUp } from 'react-icons/fa';
import { ReactNode } from 'react';

export type AccordionConfig = {
    heading: string;
    headingExtra?: ReactNode;
    name: string;
    content: ReactNode;
};

type accordionProps = {
    config: AccordionConfig,
    isOpen: boolean,
    onToggle: () => void
};

const Accordion = ({ config, isOpen, onToggle }: accordionProps) => {
    return (
        <section className="accordion">
            <h3 onClick={onToggle}>
                <span>{config.heading}</span>
                {config.headingExtra && <span className="extra">{config.headingExtra}</span>}
                <FaChevronCircleUp className={isOpen ? 'rotated' : ''} />
            </h3>
            <div className={isOpen ? 'shown' : ''}>{config.content}</div>
        </section>
    );
};

export default Accordion;